var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#patternLT)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternLT",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8917_2524",
    transform: "translate(-0.333333) scale(0.00574713)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8917_2524",
    width: 290,
    height: 174,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASIAAACuCAIAAAAd2Zf2AAAEeUlEQVR4Ae3VsUmDURhG4TuAXQawtBC3CDqIXQr3SyPYulPQKU7xwgOp7/fzwHlzHveLHwECqcBJX/c4AQKP+0Vm/swJ5AIyy4nNOQGZyYxALiCznNiWE5CZzAjkAjLLiW05AZnJjEAuILOc2JYTkJnMCOQCMsuJbTkBmcmMQC4gs5zYlhOQmcwI5AIyy4ltOQGZyYxALiCznNiWE5CZzAjkAjLLiW05AZnJjEAuILOc2JYTkJnMCOQCMsuJbTkBmcmMQC4gs5zYlhOQmcwI5AIyy4ltOQGZyYxALiCznNiWE5CZzAjkAjLLiW05AZnJjEAuILOc2JYTkJnMCOQCMsuJbTkBmcmMQC4gs5zYlhOQmcwI5AIyy4ltOQGZyYxALiCznNiWE5CZzAjkAjLLiW05AZnJjEAuILOc2JYTkJnMCOQCMsuJbTkBmcmMQC4gs5zYlhOQmcwI5AIyy4ltOQGZyYxALiCznNiWE5CZzAjkAjLLiW05AZnJjEAucP6+n/wIEEgFzvn88CNAoBU4t6sfAQKtQPu6hgkQuF2PzAgQyAXyA8aMAAGZESCQC+QHLBkBAjIjQCAXyA9YMgIEZEaAQC6QH7BkBAjIjACBXCA/YMkIEJAZAQK5QH7AkhEgIDMCBHKB/IAlI0BAZgQI5AL5AUtGgIDMCBDIBfIDlowAAZkRIJAL5AcsGQECMiNAIBfID1gyAgRkRoBALpAfsGQECMiMAIFcID9gyQgQkBkBArlAfsCSESAgMwIEcoH8gCUjQEBmBAjkAvkBS0aAgMwIEMgF8gOWjAABmREgkAvkBywZAQIyI0AgF8gPWDICBGRGgEAukB+wZAQIyIwAgVwgP2DJCBCQGQECuUB+wJIRICAzAgRygfyAJSNAQGYECOQC+QFLRoCAzAgQyAXyA5aMAAGZESCQC+QHLBkBAjIjQCAXyA9YMgIEzte7HwECrcDv86sfAQKpwPl5efMjQCAVkJmVIZALyCwnTmfS4xMCMpMZgVxAZjnxxNz6yFRAZjIjkAvILCdOZ9LjEwIykxmBXEBmOfHE3PrIVEBmMiOQC8gsJ05n0uMTAjKTGYFcQGY58cTc+shUQGYyI5ALyCwnTmfS4xMCMpMZgVxAZjnxxNz6yFRAZjIjkAvILCdOZ9LjEwIykxmBXEBmOfHE3PrIVEBmMiOQC8gsJ05n0uMTAjKTGYFcQGY58cTc+shUQGYyI5ALyCwnTmfS4xMCMpMZgVxAZjnxxNz6yFRAZjIjkAvILCdOZ9LjEwIykxmBXEBmOfHE3PrIVEBmMiOQC8gsJ05n0uMTAjKTGYFcQGY58cTc+shUQGYyI5ALyCwnTmfS4xMCMpMZgVxAZjnxxNz6yFRAZjIjkAvILCdOZ9LjEwIykxmBXEBmOfHE3PrIVEBmMiOQC8gsJ05n0uMTAjKTGYFcQGY58cTc+shUQGYyI5ALyCwnTmfS4xMCMpMZgVxAZjnxxNz6yFRAZjIjkAvILCdOZ9LjEwIykxmBXEBmOfHE3PrIVOAfzx8ZOq8pSYgAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLt);
export default __webpack_public_path__ + "static/media/LT.4a4958b46e21c0af4958070957f0bee8.svg";
export { ForwardRef as ReactComponent };